/* PTB v16 — contrôleur produit unique : variantes, disponibilité et galerie */
(function () {
  "use strict";

  var COLOR_META = {
    "Noir": ["Black", "#111111"], "Black": ["Black", "#111111"],
    "Vert Militaire": ["Military Green", "#6f765f"], "Vert militaire": ["Military Green", "#6f765f"], "Military Green": ["Military Green", "#6f765f"],
    "Tempête": ["Storm", "#77757a"], "Tempete": ["Storm", "#77757a"], "Storm": ["Storm", "#77757a"],
    "Bleu Marine": ["Navy", "#1b2748"], "Bleu marine": ["Navy", "#1b2748"], "Navy": ["Navy", "#1b2748"],
    "Blanc": ["White", "#ffffff"], "White": ["White", "#ffffff"],
    "Épicéa": ["Spruce", "#2f4f46"], "Epicéa": ["Spruce", "#2f4f46"], "Epicea": ["Spruce", "#2f4f46"], "Spruce": ["Spruce", "#2f4f46"],
    "Gris Foncé": ["Dark Grey", "#4a4a4a"], "Gris foncé": ["Dark Grey", "#4a4a4a"], "Dark Grey": ["Dark Grey", "#4a4a4a"], "Dark Gray": ["Dark Grey", "#4a4a4a"],
    "Kaki": ["Khaki", "#b7a77a"], "Khaki": ["Khaki", "#b7a77a"],
    "Pierre": ["Stone", "#c7bda8"], "Stone": ["Stone", "#c7bda8"],
    "Rose": ["Pink", "#e9a7bd"], "Pink": ["Pink", "#e9a7bd"],
    "Canneberge": ["Cranberry", "#8f263f"], "Cranberry": ["Cranberry", "#8f263f"],
    "Bleu Clair": ["Light Blue", "#9bcbe8"], "Bleu clair": ["Light Blue", "#9bcbe8"], "Light Blue": ["Light Blue", "#9bcbe8"],
    "Faded Black": ["Faded Black", "#242424"], "Faded Coal": ["Faded Coal", "#4a4a46"],
    "Faded Indigo": ["Faded Indigo", "#4b5f76"], "Faded Grey": ["Faded Grey", "#8a8985"],
    "Faded Bone": ["Faded Bone", "#d7cfbd"], "Faded Khaki": ["Faded Khaki", "#8f886d"],
    "Faded Eucalyptus": ["Faded Eucalyptus", "#71877b"]
  };

  function inferGalleryColor(url) {
    url = String(url || "").toLowerCase();
    var map = [
      ["faded-eucalyptus", "Faded Eucalyptus"], ["faded-indigo", "Faded Indigo"],
      ["faded-black", "Faded Black"], ["faded-coal", "Faded Coal"],
      ["faded-grey", "Faded Grey"], ["faded-gray", "Faded Grey"],
      ["faded-bone", "Faded Bone"], ["faded-khaki", "Faded Khaki"],
      ["baby-pink", "Baby Pink"], ["light-pink", "Light Pink"],
      ["light-blue", "Light Blue"], ["dark-grey", "Dark Grey"], ["dark-gray", "Dark Grey"],
      ["military-green", "Military Green"], ["vert-militaire", "Military Green"], ["amazigh-vert-", "Military Green"],
      ["storm", "Storm"], ["tempete", "Storm"], ["tempête", "Storm"], ["amazigh-tempete-", "Storm"],
      ["spruce", "Spruce"], ["cranberry", "Cranberry"], ["khaki", "Khaki"],
      ["stone", "Stone"], ["navy", "Navy"], ["white", "White"],
      ["black", "Black"], ["pink", "Pink"]
    ];
    for (var i = 0; i < map.length; i += 1) if (url.indexOf(map[i][0]) >= 0) return map[i][1];
    return "";
  }

  function init(root) {
    var node = root.querySelector("[data-ptb-product-variants]");
    if (!node) return;
    var variants;
    try { variants = JSON.parse(node.textContent); } catch (e) { return; }
    if (!Array.isArray(variants) || !variants.length) return;

    var colorIndex = Number(root.getAttribute("data-color-index") || 0);
    var sizeIndex = Number(root.getAttribute("data-size-index") || 1);
    var currency = root.getAttribute("data-currency") || "EUR";
    var locale = (document.documentElement.lang || "fr").toLowerCase().indexOf("en") === 0 ? "en-GB" : "fr-FR";
    var colorButtons = Array.from(root.querySelectorAll("[data-ptb-color]"));
    var sizeButtons = Array.from(root.querySelectorAll("[data-ptb-size]"));
    var thumbs = Array.from(root.querySelectorAll("[data-ptb-thumb]"));
    var variantInput = root.querySelector("[data-ptb-variant-id]");
    var priceEl = root.querySelector("[data-ptb-price]");
    var addBtn = root.querySelector("[data-ptb-add]");
    var mainImage = root.querySelector("[data-ptb-main-image]");
    var noImage = root.querySelector("[data-ptb-no-image]");
    var prevBtn = root.querySelector("[data-ptb-gallery-prev]");
    var nextBtn = root.querySelector("[data-ptb-gallery-next]");
    var hasColor = colorButtons.length > 0;
    var hasSize = sizeButtons.length > 0;
    var selectedColor = null;
    var selectedSize = null;
    var visibleThumbs = [];
    var currentThumbIndex = 0;

    colorButtons.forEach(function (btn) {
      var meta = COLOR_META[btn.value];
      if (!meta) return;
      btn.setAttribute("data-gallery-color", meta[0]);
      var dot = btn.querySelector(".pdp__swatch-dot");
      if (dot) dot.style.setProperty("--swatch", meta[1]);
    });
    var VIEW_WORDS = { front: 1, back: 1, left: 1, right: 1, side: 1, flat: 1, model: 1, detail: 1 };
    function fileTokens(url) {
      var parts = String(url || "").split("?")[0].split("/").pop().replace(/[.][a-z0-9]+$/i, "").toLowerCase().split(/[^a-z0-9]+/).filter(Boolean);
      if (parts.length && /^[0-9a-f]{8,}$/.test(parts[parts.length - 1])) parts.pop();
      return parts;
    }
    function slugify(text) { return String(text || "").toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, ""); }
    /* Photo → couleur : variante, puis nom de fichier. */
    function assignThumbColors() {
      if (!hasColor || !thumbs.length) return;
      var gallery = function (btn) { return btn.getAttribute("data-gallery-color") || btn.value; };
      if (colorButtons.length === 1) {
        thumbs.forEach(function (thumb) { thumb.setAttribute("data-color", gallery(colorButtons[0])); });
        return;
      }
      var lists = thumbs.map(function (thumb) { return fileTokens(thumb.getAttribute("data-full")); });
      var prefix = 0;
      while (lists.length > 1 && lists.every(function (l) { return l.length > prefix && l[prefix] === lists[0][prefix]; })) prefix += 1;
      var entries = colorButtons.map(function (btn) {
        var variant = variants.find(function (v) { return v.options && v.options[colorIndex] === btn.value && v.image; });
        var key = variant ? fileTokens(variant.image).slice(prefix) : [];
        while (key.length && VIEW_WORDS[key[key.length - 1]]) key.pop();
        return { name: gallery(btn), key: key.join("-"), slugs: [slugify(btn.value), slugify(gallery(btn))] };
      });
      thumbs.forEach(function (thumb, i) {
        var best = null;
        var len = 0;
        var rest = lists[i].slice(prefix).join("-") + "-";
        var all = "-" + lists[i].join("-") + "-";
        entries.forEach(function (e) {
          if (e.key && e.key.length > len && rest.indexOf(e.key + "-") === 0) { best = e; len = e.key.length; }
        });
        if (!best) entries.forEach(function (e) {
          e.slugs.forEach(function (s) { if (s && s.length > len && all.indexOf("-" + s + "-") >= 0) { best = e; len = s.length; } });
        });
        var found = best ? best.name : (thumb.getAttribute("data-color") || inferGalleryColor(thumb.getAttribute("data-full") || ""));
        if (found) thumb.setAttribute("data-color", found);
      });
    }
    assignThumbColors();
    var colorAware = thumbs.some(function (thumb) { return Boolean(thumb.getAttribute("data-color")); });

    function money(cents) {
      return new Intl.NumberFormat(locale, { style: "currency", currency: currency }).format(Number(cents || 0) / 100);
    }
    function isAvailable(v) { return Boolean(v && v.id); }
    function colorMatches(v, color) { return !hasColor || (v.options && v.options[colorIndex] === color); }
    function sizeMatches(v, size) { return !hasSize || (v.options && v.options[sizeIndex] === size); }
    function candidates(color, size) {
      return variants.filter(function (v) { return colorMatches(v, color) && sizeMatches(v, size); });
    }
    function setState(buttons, value) {
      buttons.forEach(function (btn) {
        var selected = btn.value === value;
        btn.classList.toggle("is-selected", selected);
        btn.setAttribute("aria-checked", selected ? "true" : "false");
      });
    }
    function firstAvailableColor() {
      if (!hasColor) return null;
      var ok = function (btn) { return variants.some(function (v) { return colorMatches(v, btn.value) && isAvailable(v); }); };
      var hasPhotos = function (btn) {
        var g = btn.getAttribute("data-gallery-color") || btn.value;
        return !colorAware || thumbs.some(function (t) { return t.getAttribute("data-color") === g; });
      };
      var pool = colorButtons.filter(function (btn) { return ok(btn) && hasPhotos(btn); });
      if (!pool.length) pool = colorButtons.filter(ok);
      var preferred = pool.find(function (btn) { return btn.value === "White" || btn.value === "Blanc"; });
      return (preferred || pool[0] || colorButtons[0]).value;
    }
    function updateColorAvailability() {
      colorButtons.forEach(function (btn) {
        var ok = variants.some(function (v) { return colorMatches(v, btn.value) && isAvailable(v); });
        btn.disabled = !ok;
        btn.setAttribute("aria-disabled", ok ? "false" : "true");
      });
    }
    function updateSizeAvailability() {
      if (!hasSize) { selectedSize = null; return; }
      sizeButtons.forEach(function (btn) {
        var ok = variants.some(function (v) {
          return colorMatches(v, selectedColor) && sizeMatches(v, btn.value) && isAvailable(v);
        });
        btn.disabled = !ok;
        btn.setAttribute("aria-disabled", ok ? "false" : "true");
      });
      var selectedValid = sizeButtons.some(function (btn) { return btn.value === selectedSize && !btn.disabled; });
      if (!selectedValid) {
        var first = sizeButtons.find(function (btn) { return !btn.disabled; });
        selectedSize = first ? first.value : null;
      }
      setState(sizeButtons, selectedSize);
    }
    function currentVariant() {
      var exact = candidates(selectedColor, selectedSize)[0] || null;
      if (isAvailable(exact)) return exact;
      var available = variants.find(function (v) {
        return colorMatches(v, selectedColor) && (!hasSize || sizeMatches(v, selectedSize)) && isAvailable(v);
      });
      if (available) return available;
      if (hasColor) {
        available = variants.find(function (v) { return colorMatches(v, selectedColor) && isAvailable(v); });
        if (available) return available;
      }
      return variants.find(isAvailable) || exact || variants[0] || null;
    }

    function showThumb(index) {
      if (!visibleThumbs.length) return;
      currentThumbIndex = (index + visibleThumbs.length) % visibleThumbs.length;
      visibleThumbs.forEach(function (thumb, i) { thumb.classList.toggle("is-active", i === currentThumbIndex); });
      var thumb = visibleThumbs[currentThumbIndex];
      if (mainImage) {
        mainImage.hidden = false;
        mainImage.src = thumb.getAttribute("data-full") || mainImage.src;
        mainImage.alt = thumb.getAttribute("data-alt") || "Photo du produit";
      }
      if (noImage) noImage.hidden = true;
      if (visibleThumbs.length > 1) [1, visibleThumbs.length - 1].forEach(function (step) {
        var other = visibleThumbs[(currentThumbIndex + step) % visibleThumbs.length];
        var src = other && other.getAttribute("data-full");
        if (src) new Image().src = src;
      });
    }
    function updateGallery(variant) {
      var variantId = variant ? String(variant.id || "") : "";
      var mediaId = variant && variant.featured_media_id ? String(variant.featured_media_id) : "";
      var selectedButton = hasColor ? colorButtons.find(function (b) { return b.value === selectedColor; }) : null;
      var galleryColor = selectedButton ? (selectedButton.getAttribute("data-gallery-color") || selectedColor) : "";
      visibleThumbs = [];
      thumbs.forEach(function (thumb) {
        var thumbColor = thumb.getAttribute("data-color") || "";
        var thumbMedia = thumb.getAttribute("data-media-id") || "";
        var ids = (thumb.getAttribute("data-variant-ids") || "").split(",").filter(Boolean);
        var match = !hasColor || !colorAware || thumbColor === galleryColor ||
          (variantId && ids.indexOf(variantId) >= 0) || (mediaId && thumbMedia === mediaId);
        thumb.hidden = !match;
        thumb.classList.remove("is-active");
        if (match) visibleThumbs.push(thumb);
      });
      if (visibleThumbs.length) {
        var preferred = mediaId ? visibleThumbs.findIndex(function (thumb) {
          return (thumb.getAttribute("data-media-id") || "") === mediaId;
        }) : -1;
        showThumb(preferred >= 0 ? preferred : 0);
      } else if (variant && (variant.featured_media_url || variant.image) && mainImage) {
        mainImage.hidden = false;
        mainImage.src = variant.featured_media_url || variant.image;
        mainImage.alt = "Photo du produit";
        if (noImage) noImage.hidden = true;
      } else {
        if (mainImage) mainImage.hidden = true;
        if (noImage) noImage.hidden = false;
      }
      if (prevBtn) prevBtn.hidden = visibleThumbs.length <= 1;
      if (nextBtn) nextBtn.hidden = visibleThumbs.length <= 1;
    }

    function sync() {
      var variant = currentVariant();
      if (variant && hasSize && variant.options && selectedSize !== variant.options[sizeIndex]) {
        selectedSize = variant.options[sizeIndex];
        setState(sizeButtons, selectedSize);
      }
      if (variantInput) variantInput.value = variant ? variant.id : "";
      if (priceEl && variant) {
        var html = money(variant.price);
        if (variant.compare_at_price && Number(variant.compare_at_price) > Number(variant.price)) {
          html += " <s>" + money(variant.compare_at_price) + "</s>";
        }
        priceEl.innerHTML = html;
      }
      if (addBtn) {
        var ok = isAvailable(variant);
        addBtn.disabled = !ok;
        addBtn.setAttribute("aria-disabled", ok ? "false" : "true");
        addBtn.textContent = ok
          ? (addBtn.getAttribute("data-label-add") || "Ajouter au panier")
          : (addBtn.getAttribute("data-label-soldout") || "Rupture de stock");
      }
      updateGallery(variant);
    }
    function chooseColor(value) {
      var btn = colorButtons.find(function (b) { return b.value === value; });
      if (!btn || btn.disabled) return;
      selectedColor = value;
      setState(colorButtons, selectedColor);
      updateSizeAvailability();
      sync();
    }
    function chooseSize(value) {
      var btn = sizeButtons.find(function (b) { return b.value === value; });
      if (!btn || btn.disabled) return;
      selectedSize = value;
      setState(sizeButtons, selectedSize);
      sync();
    }

    colorButtons.forEach(function (btn) { btn.addEventListener("click", function (e) { e.preventDefault(); chooseColor(btn.value); }); });
    sizeButtons.forEach(function (btn) { btn.addEventListener("click", function (e) { e.preventDefault(); chooseSize(btn.value); }); });
    thumbs.forEach(function (thumb) { thumb.addEventListener("click", function () { var i = visibleThumbs.indexOf(thumb); if (i >= 0) showThumb(i); }); });
    if (prevBtn) prevBtn.addEventListener("click", function () { showThumb(currentThumbIndex - 1); });
    if (nextBtn) nextBtn.addEventListener("click", function () { showThumb(currentThumbIndex + 1); });
    var swipeBox = mainImage && mainImage.parentElement;
    var swipeFrom = null;
    if (swipeBox) {
      swipeBox.addEventListener("touchstart", function (e) {
        swipeFrom = e.touches.length === 1 ? [e.touches[0].clientX, e.touches[0].clientY] : null;
      }, { passive: true });
      swipeBox.addEventListener("touchend", function (e) {
        if (!swipeFrom || visibleThumbs.length < 2) return;
        var dx = e.changedTouches[0].clientX - swipeFrom[0];
        var dy = e.changedTouches[0].clientY - swipeFrom[1];
        swipeFrom = null;
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.2) return;
        showThumb(currentThumbIndex + ((dx < 0) !== (document.documentElement.dir === "rtl") ? 1 : -1));
      }, { passive: true });
    }

    updateColorAvailability();
    selectedColor = firstAvailableColor();
    if (hasColor) setState(colorButtons, selectedColor);
    updateSizeAvailability();
    sync();
  }

  document.querySelectorAll("[data-ptb-product-root]").forEach(init);
})();